export const FILECATEGORY = [
    { Name: "Bankutbetalning", Value: "BANKUTBETALNING" },
    { Name: "Bankinbetalning", Value: "BANKINBETALNING" },
    { Name: "Bokföring", Value: "BOKFORING" },
    { Name: "Fakturabunt", Value: "FAKTURABUNT" },
    { Name: "Fakturautskrift", Value: "FAKTURAUTSKRIFT" },
    { Name: "Bankutbetalning FTP", Value: "BANKUTBETALNING_FTP" },
    { Name: "Bankinbetalning FTP", Value: "BANKINBETALNING_FTP" },
    { Name: "Fakturabunt FTP", Value: "FAKTURABUNT_FTP" },
    { Name: "Fakturautskrift FTP", Value: "FAKTURAUTSKRIFT_FTP" },
    { Name: "Migreringssaldo", Value: "MIGRERINGSSALDO" },
    { Name: "Migrering OID", Value: "MIGRERING_OID" },
];
